import { render, staticRenderFns } from "./Contextmenu.vue?vue&type=template&id=3120fd26&scoped=true&"
import script from "./Contextmenu.vue?vue&type=script&lang=js&"
export * from "./Contextmenu.vue?vue&type=script&lang=js&"
import style0 from "./Contextmenu.vue?vue&type=style&index=0&id=3120fd26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120fd26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
